import { styled } from '@mui/material';

export const VideoW = styled('div')`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const PlayButtonContainer = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
